
export enum SalesListingSortBy {
  price= 'price',
  km= 'km',
  firstRegistrationYear= 'firstRegistrationYear',
  sellerCompany= 'sellerCompany',
  startAt= 'startAt',
  createdAt= 'createdAt',
  priority= 'priority',
  expiresAt= 'expiresAt',

}